import { createFileRoute } from '@tanstack/react-router';
import IntegrationCompany from '../admin/integration-companies/view';
export const Route = createFileRoute('/admin/integrations/companies')({
  component: IntegrationCompany,
});
